import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { FlexBox } from '../box';
import { Divider } from '../divider';
import { Typography } from '../typography';
export const InboxPanelHeader = (props) => {
    const { title, actions, className, ...rest } = props;
    return (_jsxs(FlexBox, { stack: true, className: className, "data-role": rest['data-role'] ?? 'inbox-panel-header', "data-role-value": rest['data-role-value'], children: [_jsxs(FlexBox, { padding: [1.5, 2], hAlign: "space-between", vAlign: "center", children: [_jsx(Typography, { variant: "headingSmall", fontWeight: "bold", children: title }), actions && (_jsx(FlexBox, { gap: 0.5, vAlign: "center", children: actions }))] }), _jsx(Divider, {})] }));
};
